import * as UserManualActions from '@completion/actions';

import { ManifestItem, UserManualFragment } from '@completion/models';

export interface UserManualState {
  manifest: { [manualId: string]: ManifestItem };
  fragments: { [manualId: string]: UserManualFragment };
  loadingManifest: boolean;
  loadingFragments: boolean;
  error?: any;
  manualActive: boolean;
}

export const initialState: UserManualState = {
  manifest: {},
  fragments: {},
  loadingManifest: false,
  loadingFragments: false,
  error: null,
  manualActive: false,
};

export function userManualReducer(state: UserManualState = initialState, action: any): UserManualState {
  switch (action.type) {
    case UserManualActions.UserManualActionTypes.LoadManifest:
      return { ...state, loadingManifest: true };

    case UserManualActions.UserManualActionTypes.LoadManifestSuccess: {
      // action.items may be an array (preferred) or an object/map in some flows; coerce to array safely
      const rawItems = action && action.items ? action.items : [];
      const items: any[] = Array.isArray(rawItems) ? rawItems : typeof rawItems === 'object' ? Object.values(rawItems) : [];
      const manifestMap = { ...state.manifest };
      items.forEach((i: any) => {
        // prefer numeric DB id string as the key when available; fall back to any stable key on the item
        const key = i && typeof i.id === 'number' ? String(i.id) : i && i.key ? i.key : undefined;
        if (key) {
          manifestMap[key] = i as ManifestItem;
        }
      });
      return { ...state, manifest: manifestMap, loadingManifest: false };
    }

    case UserManualActions.UserManualActionTypes.LoadManifestFailure:
      return { ...state, loadingManifest: false, error: action.error };

    case UserManualActions.UserManualActionTypes.LoadFragments:
      return { ...state, loadingFragments: true };

    case UserManualActions.UserManualActionTypes.LoadFragmentsSuccess: {
      const frags = action.fragments || [];
      const fragMap = { ...state.fragments };
      frags.forEach((f: any) => {
        const key = f.key || (f.id ? String(f.id) : undefined);
        if (key) {
          fragMap[key] = f;
        }
      });
      return { ...state, fragments: fragMap, loadingFragments: false };
    }

    case UserManualActions.UserManualActionTypes.LoadFragmentsFailure:
      return { ...state, loadingFragments: false, error: action.error };

    case UserManualActions.UserManualActionTypes.SaveFragmentSuccess: {
      const fragment = action.fragment;
      const key = fragment.key || (fragment.id ? String(fragment.id) : undefined);
      if (!key) {
        return state;
      }
      return { ...state, fragments: { ...state.fragments, [key]: fragment } };
    }

    case UserManualActions.UserManualActionTypes.RemoveFragmentSuccess: {
      const id = action.manualId || action['id'];
      const next = { ...state.fragments };
      if (id && next[id]) {
        delete next[id];
      }
      return { ...state, fragments: next };
    }

    case UserManualActions.UserManualActionTypes.SetManualActive:
      return { ...state, manualActive: action.active };

    default:
      return state;
  }
}
